<template>
  <div>
    <svg
      :style="{
        width: width || '40px',
        height: height || '40px',
      }"
      width="800px"
      height="800px"
      viewBox="-36 0 116 116"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>015-Black</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Artboard" transform="translate(-286.000000, -866.000000)">
          <g id="015-Black" transform="translate(286.000000, 866.000000)">
            <path
              d="M11.5626,40.1185 C11.5626,40.1185 2.6376,39.6995 0.9726,47.0955 C0.2626,50.2485 1.4536,56.0115 4.2146,58.9375 C5.1486,59.9285 5.3146,52.9335 5.3146,52.9335 C5.8946,64.9245 13.1786,66.3835 14.5456,66.7925 C15.6436,67.1205 20.0076,57.2435 19.1876,51.2765 C18.3686,45.3105 11.5626,40.1185 11.5626,40.1185"
              id="Fill-932"
              fill="#463141"
            ></path>
            <path
              d="M35.1545,97.9381 L29.6795,98.6631 C29.6795,98.6631 28.0485,101.5061 28.2675,103.0611 C28.4855,104.6161 35.2475,108.6701 38.6925,108.3951 C42.1365,108.1211 42.3505,104.9811 42.1065,103.7321 C41.8625,102.4821 35.1545,97.9381 35.1545,97.9381"
              id="Fill-934"
              fill="#EEA8B7"
            ></path>
            <path
              d="M39.5459,107.0848 C36.2809,107.3448 29.2719,103.5798 28.3619,101.8628 C28.2629,102.2958 28.2179,102.7108 28.2669,103.0608 C28.4859,104.6158 35.2479,108.6698 38.6919,108.3958 C40.5799,108.2448 41.4959,107.2338 41.8999,106.1448 C41.3699,106.6388 40.6139,106.9998 39.5459,107.0848"
              id="Fill-936"
              fill="#FEFDFC"
            ></path>
            <path
              d="M29.1768,99.6416 C28.7958,100.3976 28.3618,101.8626 28.3618,101.8626 C28.6998,102.6456 30.5798,103.8086 30.5798,103.8086 C31.6428,101.2036 29.1768,99.6416 29.1768,99.6416"
              id="Fill-938"
              fill="#FEFDFC"
            ></path>
            <path
              d="M39.9621,101.482 C37.4831,103.927 38.1321,107 38.1321,107 L38.5221,108.402 C38.5791,108.4 38.6371,108.4 38.6921,108.395 C42.1371,108.121 42.3501,104.981 42.1061,103.732 C42.0191,103.284 41.1021,102.414 39.9621,101.482"
              id="Fill-940"
              fill="#FEFDFC"
            ></path>
            <path
              d="M36.7167,99.0293 C36.7167,99.0293 33.9977,101.3043 33.9977,101.7253 C33.9977,102.1463 35.0647,103.1733 35.6437,103.1733 C36.2237,103.1733 38.5557,100.3783 38.5557,100.3783 C37.9617,99.0683 36.7167,99.0293 36.7167,99.0293"
              id="Fill-942"
              fill="#FEFDFC"
            ></path>
            <path
              d="M33.9259,95.7062 L31.0439,95.7102 C31.0439,95.7102 30.1799,95.7152 29.6619,96.1112 C29.1439,96.5072 29.0039,98.0012 29.7959,98.7932 C30.5889,99.5862 32.6189,99.8992 33.6319,99.4032 C35.0649,98.7022 35.6139,97.3002 35.3389,96.5682 C34.9739,95.5932 33.9259,95.7062 33.9259,95.7062"
              id="Fill-944"
              fill="#D47087"
            ></path>
            <path
              d="M16.819,102.9614 C17.581,102.3014 22.009,101.3094 22.843,102.8164 C23.747,104.4514 23.491,113.2584 21.845,114.9954 C20.199,116.7334 14.206,115.3694 13.794,113.1284 C13.383,110.8884 16.057,103.6214 16.819,102.9614"
              id="Fill-946"
              fill="#EEA8B7"
            ></path>
            <path
              d="M16.7386,105.97 C16.9986,105.726 20.9006,106.709 21.0836,107.056 C21.2666,107.403 21.0836,108.578 20.7786,108.713 C20.4736,108.849 16.5266,107.916 16.4196,107.616 C16.3126,107.316 16.4786,106.214 16.7386,105.97"
              id="Fill-948"
              fill="#FEFDFC"
            ></path>
            <path
              d="M17.0595,101.0775 C17.6085,100.3915 18.2875,100.3125 18.2875,100.3125 L21.5575,100.4975 C21.5575,100.4975 22.5615,100.8225 23.1405,101.7025 C23.5825,102.3735 23.2045,104.1105 21.9975,104.8725 C20.7915,105.6345 18.2075,105.3805 17.3805,104.1935 C16.3785,102.7555 16.7785,101.4285 17.0595,101.0775"
              id="Fill-950"
              fill="#D47087"
            ></path>
            <path
              d="M31.3911,51.5997 C31.6811,51.0277 34.4541,49.9837 35.0961,50.3697 C35.7371,50.7557 41.0171,66.9577 41.0171,66.9577 C41.0171,66.9577 43.6991,68.4547 43.6331,71.9157 C43.5911,74.1307 41.8891,75.3427 40.1311,75.7927 C38.3731,76.2427 38.0061,71.4747 38.0061,71.4747 C38.0061,71.4747 37.7681,71.6747 36.6881,71.7887 C35.6091,71.9037 34.5941,71.3697 34.6551,70.7657 C34.7151,70.1617 37.4591,68.2357 37.4591,68.2357 C37.4591,68.2357 31.1011,52.1717 31.3911,51.5997"
              id="Fill-952"
              fill="#F3B679"
            ></path>
            <path
              d="M35.0956,50.3695 C35.2266,50.4485 35.5546,51.1965 35.9886,52.3245 C35.3796,53.0155 34.2566,53.9415 32.2906,54.6495 C31.6936,52.9545 31.3156,51.7485 31.3906,51.5995 C31.6806,51.0285 34.4546,49.9835 35.0956,50.3695"
              id="Fill-954"
              fill="#D58F66"
            ></path>
            <path
              d="M28.4205,41.4223 L32.9015,52.9193 C35.8095,51.5023 36.0375,50.0243 35.8475,49.3023 C34.7655,45.2013 28.4205,41.4223 28.4205,41.4223"
              id="Fill-956"
              fill="#D47087"
            ></path>
            <path
              d="M32.9013,52.9198 C35.8103,51.5028 36.0373,50.0238 35.8473,49.3028 C35.7513,48.9388 35.6133,48.5758 35.4453,48.2158 C34.6033,49.7278 33.3383,50.7698 32.3483,51.4088 L32.9013,52.9198 Z"
              id="Fill-958"
              fill="#B55D75"
            ></path>
            <path
              d="M18.9734,68.0732 L23.3194,68.0732 C23.3194,68.0732 21.7444,101.8762 21.3254,102.4572 C20.9064,103.0392 18.7264,102.8782 18.3674,102.3352 C18.0084,101.7912 18.9734,68.0732 18.9734,68.0732"
              id="Fill-964"
              fill="#F3B679"
            ></path>
            <path
              d="M28.014,67.4705 L32.259,66.0115 C32.259,66.0115 33.904,96.4205 33.485,97.0015 C33.066,97.5825 31.205,97.9515 30.846,97.4075 C30.487,96.8645 28.014,67.4705 28.014,67.4705"
              id="Fill-966"
              fill="#F3B679"
            ></path>
            <path
              d="M34.1806,67.2749 C34.1806,67.2749 35.9156,81.7089 35.9156,83.4759 C35.9156,86.2769 27.4956,86.8269 26.6356,86.2769 C25.7766,85.7259 25.7766,68.9849 25.7766,68.9849 L34.1806,67.2749 Z"
              id="Fill-968"
              fill="#EEA8B7"
            ></path>
            <path
              d="M28.6214,86.4578 C27.6294,86.4878 26.8634,86.4228 26.6364,86.2768 C26.1064,85.9368 25.9034,79.4518 25.8254,74.5218 L28.6214,86.4578 Z"
              id="Fill-970"
              fill="#B55D75"
            ></path>
            <path
              d="M26.9091,70.2534 C26.9091,70.2534 27.0831,85.2064 26.8671,86.9604 C26.5261,89.7404 17.1731,88.3614 16.3861,87.7104 C15.6001,87.0584 17.1271,69.6294 17.1271,69.6294 L26.9091,70.2534 Z"
              id="Fill-972"
              fill="#EEA8B7"
            ></path>
            <path
              d="M16.9275,72.0326 C17.0685,70.2556 17.1275,69.6296 17.1275,69.6296 L25.7795,70.1816 C25.7765,69.4346 25.7765,68.9856 25.7765,68.9856 L34.1805,67.2746 C34.1805,67.2746 34.2805,68.1006 34.4605,69.6296 C29.3425,73.5156 19.5165,72.8776 16.9275,72.0326"
              id="Fill-974"
              fill="#B55D75"
            ></path>
            <path
              d="M23.891,38.8668 C15.86,39.2768 14.822,69.2688 16.388,70.3878 C17.955,71.5068 31.894,72.2018 36.277,66.0118 C37.476,64.3178 31.922,38.4568 23.891,38.8668"
              id="Fill-976"
              fill="#EEA8B7"
            ></path>
            <path
              d="M20.9192,42.6864 C20.9192,42.6864 23.3222,45.4844 25.9622,44.9874 C28.6212,44.4874 28.0872,41.4224 28.0872,41.4224 L20.9192,42.6864 Z"
              id="Fill-978"
              fill="#B55D75"
            ></path>
            <path
              d="M21.3999,41.6015 C21.3999,41.6015 23.4489,44.9345 25.9619,43.9875 C27.9609,43.2345 27.2679,40.3225 27.2679,40.3225 L21.3999,41.6015 Z"
              id="Fill-980"
              fill="#D58F66"
            ></path>
            <path
              d="M18.9569,57.7156 C18.6189,57.1706 15.7669,56.3666 15.1609,56.8066 C14.5549,57.2456 10.6769,73.8396 10.6769,73.8396 C10.6769,73.8396 8.1329,75.5596 8.4939,79.0026 C8.7249,81.2066 10.5249,82.2676 12.3149,82.5666 C14.1039,82.8646 13.7229,77.9556 13.7229,77.9556 C13.7229,77.9556 14.3169,78.2616 15.4019,78.2836 C16.4879,78.3056 17.4529,77.6866 17.3409,77.0896 C17.2289,76.4936 14.3309,74.8086 14.3309,74.8086 C14.3309,74.8086 19.2949,58.2606 18.9569,57.7156"
              id="Fill-982"
              fill="#F3B679"
            ></path>
            <path
              d="M18.8245,44.1145 C17.3515,44.7905 12.2625,54.5985 13.4365,56.0145 C13.9915,56.6845 19.4025,58.1025 20.3345,57.7305 C21.2665,57.3575 22.5135,48.0925 21.8465,45.9255 C21.1785,43.7575 18.8245,44.1145 18.8245,44.1145"
              id="Fill-984"
              fill="#D47087"
            ></path>
            <path
              d="M18.9569,57.7156 C18.6189,57.1706 15.7669,56.3666 15.1609,56.8066 C15.0739,56.8686 14.9189,57.2706 14.7199,57.8986 C15.8719,58.3136 17.5379,58.7426 18.7849,58.9336 C18.9369,58.2436 19.0079,57.7976 18.9569,57.7156"
              id="Fill-986"
              fill="#D58F66"
            ></path>
            <path
              d="M13.3997,54.3208 C13.2177,55.1238 13.2037,55.7338 13.4357,56.0148 C13.9907,56.6848 19.4027,58.1028 20.3347,57.7298 C20.5267,57.6538 20.7247,57.0958 20.9197,56.2578 C19.2147,56.1758 14.7677,55.0018 13.3997,54.3208"
              id="Fill-988"
              fill="#B55D75"
            ></path>
            <path
              d="M13.8724,111.3206 C17.6294,109.5056 21.6574,111.7886 22.7014,113.0686 C22.4754,113.9336 22.1924,114.6276 21.8444,114.9956 C20.1984,116.7326 14.2064,115.3686 13.7944,113.1286 C13.7144,112.6906 13.7544,112.0566 13.8724,111.3206"
              id="Fill-990"
              fill="#FEFDFC"
            ></path>
            <path
              d="M10.2015,36.4357 C9.2955,36.6587 8.1315,39.2487 8.5235,40.4067 C8.9155,41.5657 11.8795,42.9937 12.9985,42.9937 C14.1165,42.9937 15.8165,40.8257 15.3865,39.5817 C14.9555,38.3377 11.2645,36.1747 10.2015,36.4357"
              id="Fill-992"
              fill="#B55D75"
            ></path>
            <path
              d="M38.1407,33.0187 C35.0177,41.6177 20.8127,43.9267 17.0867,41.9607 C11.9727,39.2637 9.3497,30.3937 9.3497,30.3937 L34.2137,8.3677 C34.2137,8.3677 40.0917,27.6457 38.1407,33.0187"
              id="Fill-994"
              fill="#F3B679"
            ></path>
            <path
              d="M34.2141,28.0567 C34.2141,27.1187 34.7601,26.3577 35.4341,26.3577 C36.1081,26.3577 36.6541,27.1187 36.6541,28.0567 C36.6541,28.9947 36.1081,29.7557 35.4341,29.7557 C34.7601,29.7557 34.2141,28.9947 34.2141,28.0567"
              id="Fill-996"
              fill="#050000"
            ></path>
            <path
              d="M22.1819,33.7839 C22.1819,32.8459 22.7279,32.0849 23.4019,32.0849 C24.0759,32.0849 24.6219,32.8459 24.6219,33.7839 C24.6219,34.7219 24.0759,35.4829 23.4019,35.4829 C22.7279,35.4829 22.1819,34.7219 22.1819,33.7839"
              id="Fill-998"
              fill="#050000"
            ></path>
            <path
              d="M21.898,38.6288 C21.898,37.4058 21.072,36.4138 20.052,36.4138 C19.033,36.4138 18.206,37.4058 18.206,38.6288 C18.206,39.8518 19.033,40.8438 20.052,40.8438 C21.072,40.8438 21.898,39.8518 21.898,38.6288"
              id="Fill-1000"
              fill="#EB8E71"
            ></path>
            <path
              d="M36.6545,9.2819 C33.4325,1.6639 20.0525,1.0779 13.7865,6.2239 C8.8055,10.3149 5.0485,20.1239 8.7215,30.9639 C9.9335,34.5419 25.0695,31.1169 30.9755,17.6649 C30.9755,17.6649 31.4305,20.6469 32.9535,21.0429 C33.9515,21.3019 36.3615,16.8089 36.3615,16.8089 L37.8985,23.6799 C37.8985,23.6799 39.9725,17.1259 36.6545,9.2819"
              id="Fill-1002"
              fill="#D58F66"
            ></path>
            <path
              d="M36.6545,7.2818 C32.9255,-0.1012 20.0525,-0.9222 13.7865,4.2238 C8.8055,8.3148 5.0035,20.2408 8.6765,31.0808 C9.9505,34.8408 25.9425,28.3878 31.0885,13.1738 C31.0885,13.1738 31.9835,18.6928 32.9535,19.0428 C33.9225,19.3928 35.9495,14.9638 35.9495,14.9638 L37.8985,23.6798 C37.8985,23.6798 40.6845,15.2608 36.6545,7.2818"
              id="Fill-1004"
              fill="#5C4555"
            ></path>
            <path
              d="M9.9273,32.0544 C9.9273,32.0544 7.2953,31.9284 6.7983,33.7874 C6.4253,35.1864 6.9373,37.5214 8.3543,38.1614 C9.7713,38.8004 12.4663,37.2554 12.4663,37.2554 L9.9273,32.0544 Z"
              id="Fill-1006"
              fill="#F3B679"
            ></path>
            <path
              d="M34.1747,4.2296 C33.3857,4.1696 21.3677,2.7856 16.8987,7.4236 C9.3497,15.2576 9.3497,31.7376 9.3497,31.7376 L9.0507,31.6336 C8.8807,31.4826 8.7507,31.3006 8.6767,31.0806 C5.0037,20.2406 8.8057,8.3146 13.7867,4.2236 C19.0387,-0.0894 28.9147,-0.1924 34.1747,4.2296"
              id="Fill-1008"
              fill="#463141"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "GirlIcon",
  props: ["width", "height"],
};
</script>

<style>
</style>